import React from 'react'
import { ThemeConfig } from '../../utils/themeConfig'

interface PaymentGuideCardProps {
  themeConfig: ThemeConfig
}

export default function PaymentGuideCard({ themeConfig }: PaymentGuideCardProps) {
  return (
    <div className="bg-white rounded-xl p-4 lg:p-5 shadow-sm">
      <h3 className="text-base lg:text-lg font-bold text-gray-800 mb-3 lg:mb-4">支付成功后如何查看报告？</h3>
      <div className="space-y-2.5">
        <div className="flex items-start gap-2.5">
          <div
            className="w-1.5 h-1.5 rounded-full mt-1.5 flex-shrink-0"
            style={{ backgroundColor: themeConfig.primaryColor }}
          ></div>
          <span className="text-sm text-gray-700 leading-relaxed">已付费查询用户可点击右侧历史报告查看报告</span>
        </div>
        <div className="flex items-start gap-2.5">
          <div
            className="w-1.5 h-1.5 rounded-full mt-1.5 flex-shrink-0"
            style={{ backgroundColor: themeConfig.primaryColor }}
          ></div>
          <span className="text-sm text-gray-700 leading-relaxed">
            由于短信可能延迟或无法送达，
            <span className="font-semibold" style={{ color: themeConfig.primaryColor }}>
              支付成功后请重新扫码进入当前页面，点击右侧绿色"查看报告"按钮
            </span>
            ，即可立即查看您的报告。
          </span>
        </div>
        <div className="flex items-start gap-2.5">
          <div
            className="w-1.5 h-1.5 rounded-full mt-1.5 flex-shrink-0"
            style={{ backgroundColor: themeConfig.primaryColor }}
          ></div>
          <span className="text-sm text-gray-700 leading-relaxed">
            付费之后报告十分钟内未生成或者对报告数据存在任何疑问，可点击右下角按钮联系客服咨询。
          </span>
        </div>
      </div>
    </div>
  )
}
